module.exports = __webpack_public_path__ + "img/solicitacoes.1d75ad54.svg";